"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const debug_provider_1 = require("./debug-provider");
const debug_pill_1 = __importDefault(require("./debug-pill"));
const PageDebug = ({ pageResources }) => {
    const { showTemplateNames } = (0, debug_provider_1.useDebug)();
    if (showTemplateNames) {
        return (react_1.default.createElement(debug_pill_1.default, null,
            "Template:",
            ' ',
            pageResources.page.componentChunkName));
    }
    return null;
};
exports.default = PageDebug;
//# sourceMappingURL=page-debug.js.map